import { render, staticRenderFns } from "./AssetIndex.vue?vue&type=template&id=2188c06f&scoped=true"
import script from "./AssetIndex.vue?vue&type=script&lang=js"
export * from "./AssetIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2188c06f",
  null
  
)

export default component.exports